import type { SVGProps } from 'react';

interface ArrowUpIconProps extends SVGProps<SVGSVGElement> {
    className?: string;
}

export function ArrowUpIcon({ className, ...props }: ArrowUpIconProps) {
    return (
        <svg className={className} {...props} xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
            <path d="M5.75 0.75L10.75 5.89286M5.75 0.75L0.75 5.89286M5.75 0.75V12.75" stroke="#9A9691" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
